import http_config from '../../common/config/http_config';
import axiosInstance from '../../common/helper/axiosInterceptor';
import { AttendanceResponseModel, StaffAttendanceResponseModel } from './attendance.model';

export const onGetAttendance = (
  grade: string,
  section: string,
  month: string,
  year: string,
): Promise<AttendanceResponseModel[]> => {
  console.log(
    http_config.BASE_URL +
      '/attendance/grade/' +
      grade +
      '/section/' +
      section +
      '/date/' +
      `${year}-${month}-01`,
  );
  return axiosInstance.get(
    http_config.BASE_URL +
      '/attendance/grade/' +
      grade +
      '/section/' +
      section +
      '/month/' +
      `${year}-${month}-01`,
  );
};

export const onGetStaffAttendance = (): Promise<StaffAttendanceResponseModel[]> => {
  return axiosInstance.get(http_config.BASE_URL + '/attendance/staff');
};
